import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const RootContainer = styled(Common.RootContainer)``;

export const Container = styled(Common.Container)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const ButtonWithLoader = styled(Common.ButtonWithLoader)``;

export const Accordion = styled(Common.Accordion)``;

export const AccordionSummary = styled(Common.AccordionSummary)``;

export const AccordionDetails = styled(Common.AccordionDetails)``;

export const TitleSection = styled(Common.TitleSection)``;

export const TitleRow = styled(Common.TitleRow)``;

export const Title = styled(Common.Title)``;

export const Subtitle = styled(Common.Subtitle)``;

export const InputGroup = styled(Common.InputGroup)``;

export const Password = styled(Common.Password)``;
